import { Button, Typography } from '@mui/material';
import RightIcon from 'src/icons/untitled-ui/duocolor/rightIcon';
import {
  getPatientIdAction,
  switchTherapistDisciplineAction,
} from 'src/redux/actions/patientAction';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { paths, permissions } from 'src/paths';
import { useCallback } from 'react';

interface RedirectByActionAlertProps {
  data: any;
}

export const RedirectByActionAlert: React.FC<RedirectByActionAlertProps> = ({ data }) => {
  const redirectPath: string = data?.redirectTo || '';
  let title = '';
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    patients,
    patientDetails,
    episodeOfCare,
    details,
    laborManagement,
    dailySessionNotes,
    mdsCommunication,
  } = paths;
  const permissionData = useSelector(
    (state: any) => state?.getTherapistProfileReducer?.response?.data?.currentPermissions
  );

  const { READ_PATIENT, READ_DAILY_SESSION_NOTES, READ_MY_AVAILABILITY } = permissions;

  const handleThemeClick = useCallback(
    (data: any) => {
      switch (data?.redirectTo) {
        case 'PATIENT':
          if (!data?.patientId) {
            return null;
          }
          dispatch(getPatientIdAction(data?.patientId));
          navigate(`${patients}/${patientDetails}`);
          break;
        case 'EPISODE_OF_CARE':
        case 'EOC_DOCUMENT':
          if (!data?.patientId || !data?.eocId) {
            return null;
          }
          dispatch(getPatientIdAction(data?.patientId));
          dispatch(switchTherapistDisciplineAction(''));
          navigate(`${patients}/${patientDetails}${episodeOfCare}${details}`, {
            state: {
              episodeOfCareId: data?.eocId,
              getPatientId: data?.patientId,
            },
          });
          break;
        case 'MY_AVAILABILITY':
          navigate(`${laborManagement.index}/${laborManagement.myAvailability}`);
          break;
        case 'CLOCK_IN_OUT':
          navigate(`${laborManagement.index}/${laborManagement.checkInCheckOut}`);
          break;
        case 'REPORT_AND_APPROVAL':
          navigate(`${laborManagement.index}/${laborManagement.laborReportAndApproval}`);
          break;
        case 'DAILY_SESSION_NOTE':
          navigate(dailySessionNotes);
          break;
        case 'MDS_COMMUNICATION':
          if (!data?.patientId || !data?.eocId) {
            return null;
          }
          dispatch(getPatientIdAction(data?.patientId));
          navigate(`${patients}/${patientDetails}${mdsCommunication}`, {
            state: {
              patientId: data?.patientId,
            },
          });
          break;
        default:
          return;
      }
    },
    [data]
  );

  switch (redirectPath) {
    case 'EPISODE_OF_CARE':
    case 'EOC_DOCUMENT':
      title = 'Go to Episode of Care';
      break;
    case 'PATIENT':
      title = 'Go to Patient Details';
      break;
    case 'MY_AVAILABILITY':
      title = 'Go to Labor Management - My Availability';
      break;
    case 'CLOCK_IN_OUT':
      title = 'Go to Labor Management - Clock in/out';
      break;
    case 'REPORT_AND_APPROVAL':
      title = 'Go to Labor Management - Labor Report and Approval';
      break;
    case 'DAILY_SESSION_NOTE':
      title = 'Go To Daily Session Notes';
      break;
    case 'MDS_COMMUNICATION':
      title = 'Go to MDS Assessment';
      break;
    default:
      break;
  }

  const disableRedirection = (data: any) => {
    if (
      (data?.redirectTo === 'PATIENT' ||
        data?.redirectTo === 'EOC_DOCUMENT' ||
        data?.redirectTo === 'EPISODE_OF_CARE') &&
      !permissionData?.includes(READ_PATIENT)
    ) {
      return true;
    }

    if (data?.redirectTo === 'MY_AVAILABILITY' && !permissionData?.includes(READ_MY_AVAILABILITY)) {
      return true;
    }

    if (
      data?.redirectTo === 'DAILY_SESSION_NOTE' &&
      !permissionData?.includes(READ_DAILY_SESSION_NOTES)
    ) {
      return true;
    }

    return false;
  };

  return (
    <Typography>
      <Button
        onClick={() => handleThemeClick(data)}
        endIcon={<RightIcon />}
        disabled={disableRedirection(data)}
      >
        {title}
      </Button>
    </Typography>
  );
};
